import { create } from 'zustand';

export type ToastKind = 'info' | 'ok' | 'warn' | 'err';

export interface Toast {
  id: string;
  kind: ToastKind;
  message: string;
  createdAt: number;
}

interface ToastStore {
  toasts: Toast[];
  push: (kind: ToastKind, message: string) => string;
  dismiss: (id: string) => void;
}

export const useToastStore = create<ToastStore>((set) => ({
  toasts: [],
  push: (kind, message) => {
    const id = crypto.randomUUID();
    const toast: Toast = { id, kind, message, createdAt: Date.now() };
    set((s) => ({ toasts: [...s.toasts, toast].slice(-3) }));
    return id;
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

export const toast = {
  info: (m: string) => useToastStore.getState().push('info', m),
  ok: (m: string) => useToastStore.getState().push('ok', m),
  warn: (m: string) => useToastStore.getState().push('warn', m),
  err: (m: string) => useToastStore.getState().push('err', m),
};
